import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section4 .swiper", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 10,
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
         spaceBetween: 10,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 10,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});